import { useCallback, useEffect, useState } from 'react';

/**
 * Live actual costs for the Project page, straight from the diary + ledger:
 *   summary   → GET /diary/projects/{id}/cost-summary (labour/material/plant totals)
 *   labourLog → GET /diary/projects/{id}/labour-log (per person-day)
 *   ledger    → GET /cost-ledger/entries?project_id&category=material,plant,fuel,other (latest receipts — everything but labour)
 */
export function useProjectLiveCosts(api, projectId, refreshKey = 0) {
  const [data, setData] = useState({ summary: null, labourLog: null, ledger: null, loading: true });

  const load = useCallback(async () => {
    const g = (url, fb) => api.get(url).then(r => r.data).catch(() => fb);
    const [summary, labourLog, ledger] = await Promise.all([
      g(`/diary/projects/${projectId}/cost-summary`, null),
      g(`/diary/projects/${projectId}/labour-log`, null),
      g(`/cost-ledger/entries?project_id=${projectId}&category=material,plant,fuel,other&limit=8`, null),
    ]);
    setData({ summary, labourLog, ledger, loading: false });
  }, [api, projectId]);

  useEffect(() => { if (projectId) load(); }, [load, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { ...data, reload: load };
}
